<script lang="ts">
  import { Pacientes, type Paciente } from '../lib/api';

  type Props = {
    value: string;
    onPick: (id: string, p?: Paciente) => void;
    placeholder?: string;
  };
  let { value = $bindable(''), onPick, placeholder = 'Buscar paciente…' }: Props = $props();

  let q = $state('');
  let results = $state<Paciente[]>([]);
  let open = $state(false);
  let loading = $state(false);
  let timer: ReturnType<typeof setTimeout>;

  function search(text: string) {
    clearTimeout(timer);
    const term = text.trim();
    if (term.length < 2) {
      results = [];
      open = false;
      loading = false;
      return;
    }
    timer = setTimeout(async () => {
      loading = true;
      try {
        results = await Pacientes.list(term);
        open = true;
      } catch {
        results = [];
        open = true;
      } finally {
        loading = false;
      }
    }, 200);
  }

  function pick(p: Paciente) {
    value = p.id!;
    q = `${p.nombres} ${p.apellidos}`.trim() + (p.cui ? ` · ${p.cui}` : '');
    open = false;
    onPick(p.id!, p);
  }

  function clear() {
    value = '';
    q = '';
    results = [];
    open = false;
    onPick('');
  }

  function onType() {
    if (value) {
      value = '';
    }
    search(q);
  }

  // Si el padre limpia `value` (p. ej. tras Ingresar), también limpia la etiqueta visible.
  $effect(() => {
    if (!value) {
      q = '';
      results = [];
      open = false;
    }
  });
</script>

<div class="picker">
  <input
    type="text"
    bind:value={q}
    placeholder={placeholder}
    autocomplete="off"
    oninput={onType}
    onkeydown={(e) => { if (e.key === 'Escape') { open = false; } }}
    onblur={() => { setTimeout(() => { open = false; }, 180); }}
  />
  {#if q || value}<button type="button" class="clear" onclick={clear} title="Limpiar búsqueda">×</button>{/if}

  {#if open && (loading || results.length > 0 || q.trim().length >= 2)}
    <ul class="menu">
      {#if loading}<li class="hint">Buscando…</li>{/if}
      {#each results as p (p.id)}
        <li>
          <button type="button" onmousedown={(e) => e.preventDefault()} onclick={() => pick(p)}>
            <strong>{p.nombres} {p.apellidos}</strong>
            {#if p.cui}<span class="cui">{p.cui}</span>{/if}
          </button>
        </li>
      {:else}
        {#if !loading}<li class="hint">Sin resultados. Escriba nombre o CUI.</li>{/if}
      {/each}
    </ul>
  {/if}
</div>

<style>
  .picker { position: relative; min-width: 260px; flex: 1; }
  input { width: 100%; padding: .5rem .65rem; padding-right: 2rem; border-radius: 8px; border: 1px solid #ccc; font: inherit; }
  .clear { position: absolute; right: .25rem; top: 50%; transform: translateY(-50%); background: transparent; border: 0; font-size: 1.2rem; color: #888; cursor: pointer; padding: 0 .5rem; }
  .menu { position: absolute; top: 100%; left: 0; right: 0; background: #fff; border: 1px solid #ddd; border-radius: 8px; box-shadow: 0 6px 18px rgba(0,0,0,.08); margin: .25rem 0 0; padding: .25rem 0; list-style: none; max-height: 260px; overflow: auto; z-index: 40; }
  .menu li button { width: 100%; text-align: left; padding: .45rem .7rem; background: transparent; border: 0; cursor: pointer; font: inherit; display: flex; justify-content: space-between; gap: .5rem; }
  .menu li button:hover { background: #f5f7fb; }
  .cui { color: #666; font-size: .8rem; }
  .hint { padding: .45rem .7rem; color: #888; font-size: .85rem; font-style: italic; }
</style>
